module.exports = __webpack_public_path__ + "img/13.81a77435.jpg";